<template>
    <div :class="['form-input-radio-button form-input-radio-button--boolean', { }]">
        <div class="form-input-radio-button-inner">
            <span class="text-big">{{ label }}</span>

            <div class="radio-wrapper">
                <input :id="name+'-1'" class="input-radio" type="radio" :name="name" value="1" hidden="hidden">
                <label :for="name+'-1'" @click="setValue(1)">
                    <figure>
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.5 11.2188L1.98438 7.70312C1.60938 7.32812 1 7.32812 0.578125 7.70312C0.203125 8.07812 0.203125 8.6875 0.578125 9.10938L4.79688 13.2812C5.17188 13.7031 5.82812 13.7031 6.20312 13.2812L16.7969 2.6875C17.1719 2.3125 17.1719 1.70312 16.7969 1.28125C16.4219 0.90625 15.8125 0.90625 15.3906 1.28125L5.5 11.2188Z" fill="#676486"/>
                        </svg>
                    </figure>
                    <span>Ja</span>
                </label>
                <input :id="name+'-2'" class="input-radio" type="radio" :name="name" value="0" hidden="hidden">
                <label :for="name+'-2'" @click="setValue(0)">
                    <figure>
                        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.7812 0.71875C13.4062 0.296875 12.7969 0.296875 12.375 0.71875L7.5 5.59375L2.625 0.71875C2.20312 0.296875 1.59375 0.296875 1.21875 0.71875C0.796875 1.09375 0.796875 1.70312 1.21875 2.125L6.09375 7L1.21875 11.875C0.796875 12.2969 0.796875 12.9062 1.21875 13.2812C1.59375 13.7031 2.20312 13.7031 2.625 13.2812L7.5 8.40625L12.375 13.2812C12.7969 13.7031 13.4062 13.7031 13.7812 13.2812C14.2031 12.9062 14.2031 12.2969 13.7812 11.875L8.90625 7L13.7812 2.125C14.2031 1.75 14.2031 1.09375 13.7812 0.71875Z" fill="#827F9B"/>
                        </svg>
                    </figure>
                    <span>Nein</span>
                </label>
            </div>
        </div>

        <p v-if="text">{{ text }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                required: true
            },

            label: {
                type: String,
                required: true
            },

            text: {
                type: String,
                required: false
            },
        },

        data() {
            return {
                isActive: false
            }
        },

        mounted() {
            
        },

        methods: {
            setValue(value) {  
                this.$emit('onClick', this.name, value)
            },
        }
    }
</script>
